import $ from 'jquery';
import 'select2.full';


$('select').select2({
    width: '100%',
    minimumResultsForSearch: -1, // disable search box
});

$('select.help-interferer__pages').select2({
    width: '100%',
    minimumResultsForSearch: -1, // disable search box
    dropdownCssClass: 'select2-dropdown--fix-help-interferer-pages'
});

$('select.help-interferer__links').select2({
    width: '100%',
    minimumResultsForSearch: -1, // disable search box
    dropdownCssClass: 'select2-dropdown--fix-help-interferer-links'
});


